function safeDecode(value) {
  if (value === undefined || value === null) return "";
  const raw = String(value);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

function normalizeGuruRouteName(value) {
  return safeDecode(value).trim().toLowerCase();
}

function getGuruRouteName(guru) {
  return String(guru?.leader || guru?.nickname || guru?.guruid || "").trim();
}

export function buildPortfolioGuruPath(category, guru) {
  const normalizedCategory = String(category || "guru").toLowerCase();
  const routeName = getGuruRouteName(guru);
  if (!routeName) return `/${normalizedCategory}`;
  return `/${normalizedCategory}/${encodeURIComponent(routeName)}`;
}

export function matchesGuruRouteName(guru, routeName) {
  const normalizedRouteName = normalizeGuruRouteName(routeName);
  if (!normalizedRouteName) return false;

  const candidates = [
    guru?.leader,
    guru?.nickname,
    guru?.guruid,
  ];

  return candidates.some((candidate) => normalizeGuruRouteName(candidate) === normalizedRouteName);
}
